import React, { useEffect, useState } from "react";
import { Alert, CircularProgress } from "@mui/material";
import unsplash from "../api/unsplash";

const lookups = new Map();
export function useBillingAreas() {
  const [areas, setAreas] = useState(null);
  useEffect(() => {
    let active = true;
    const token = localStorage.getItem("jwt");
    if (!lookups.has(token))
      lookups.set(
        token,
        unsplash.get("fatturazioneAccesso", {
          headers: { Authorization: `Bearer ${token}` },
        }),
      );
    lookups
      .get(token)
      .then((response) => {
        if (active) setAreas(response.data.data);
      })
      .catch(() => {
        if (active) setAreas({});
      });
    return () => {
      active = false;
    };
  }, []);
  return areas;
}
export default function BillingAreaGuard({ area, children, silent = false }) {
  const areas = useBillingAreas();
  if (areas === null)
    return silent ? null : (
      <CircularProgress size={20} aria-label="Verifica accesso fatturazione" />
    );
  if (!areas[area])
    return silent ? null : (
      <Alert severity="info">Fatturazione riservata all’area {area}.</Alert>
    );
  return children;
}
